import { useCallback, useMemo, useState } from "react";
import { LayoutChangeEvent, Platform, useWindowDimensions } from "react-native";
import { useKeyboard } from "../../OS/useKeyboard";
import { useSizeClass } from "../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

export function useKeyboardInModal() {
  const dimensions = useWindowDimensions();
  const keyboard = useKeyboard();
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const [modalBottomInset, setModalBottomInset] = useState(0);
  const onLayout = useCallback(
    ({ nativeEvent }: LayoutChangeEvent) => {
      setModalBottomInset(
        dimensions.height - nativeEvent.layout.height - nativeEvent.layout.y
      );
    },
    [dimensions.height]
  );
  const keyboardBottomInset = useMemo(() => {
    if (isCompact) {
      return keyboard.availableRect.bottom;
    } else {
      return (
        keyboard.availableRect.bottom +
        (keyboard.keyboardShown ? 100 : 0) -
        modalBottomInset
      );
    }
  }, [
    isCompact,
    keyboard.availableRect.bottom,
    keyboard.keyboardShown,
    modalBottomInset,
  ]);

  return [
    Platform.OS === "ios" ? keyboardBottomInset : 0,
    {
      onLayout: Platform.OS === "ios" ? onLayout : undefined,
      keyboardShown: keyboard.keyboardShown,
    },
  ] as const;
}
